module.exports = __webpack_public_path__ + "static/media/profile.5656ec9f.png";